import React, { useState } from 'react';
import '../styles/sidebar.scss';
import { AiOutlineHome, AiOutlineMenu } from 'react-icons/ai';
import { FaUserShield } from "react-icons/fa";
import { FiLogOut } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import useLogout from '../hooks/useLogout'
import { FaFileSignature } from "react-icons/fa6";
import { MdReport } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { FiBell } from "react-icons/fi";
import { HiOutlineUserGroup } from "react-icons/hi";

const SideBar = ({theme,toggleTheme}) => {
    const [active,setActive] = useState(false);
    const user = useSelector(state => state.userController.user);
    const { logout } = useLogout();
    const { pathname } = useLocation();

    const showTap = tap => (user.access.includes(tap) || user.access.includes('owner'))

    return (
        <>
            <aside className={`sidebar ${active? `active`:''}`}>
                <button className="slideBtn" onClick={()=>setActive(prev => !prev)}>
                    {AiOutlineMenu({})}
                </button>
                <div className="logo">
                    <img src="/images/logo.png" alt="Logo" />
                </div>
                <ul className="ul" role="list">
                    <Link to="/">
                        <li
                            className={`li ${pathname === '/' && 'active'}`}
                            onClick={()=>setActive(false)}
                        >
                            <span className="icon">{AiOutlineHome({})}</span>
                            <p className="text">الرئيسية</p>
                        </li>
                    </Link>
                    {showTap('applications') && (
                        <Link to="/applications">
                            <li
                                className={`li ${pathname === '/applications' && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{FaFileSignature({})}</span>
                                <p className="text">طلبات التجنيد</p>
                            </li>
                        </Link>
                    )}
                    {showTap('groups') && (
                        <Link to="/groups">
                            <li
                                className={`li ${pathname.startsWith('/groups') && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{HiOutlineUserGroup({})}</span>
                                <p className="text">المجموعات</p>
                            </li>
                        </Link>
                    )}
                    {showTap('notifications') && (
                        <Link to="/notifications">
                            <li
                                className={`li ${pathname === '/notifications' && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{FiBell({})}</span>
                                <p className="text">الإشعارات</p>
                            </li>
                        </Link>
                    )}
                    {showTap('reports') && (
                        <Link to="/reports">
                            <li
                                className={`li ${pathname.startsWith('/reports') && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{MdReport({})}</span>
                                <p className="text">التقارير</p>
                            </li>
                        </Link>
                    )}
                    {showTap('settings') && (
                        <Link to="/settings">
                            <li
                                className={`li ${pathname === '/settings' && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{IoSettingsOutline({})}</span>
                                <p className="text">الإعدادات</p>
                            </li>
                        </Link>
                    )}
                    {(user.access.includes('owner')) && (
                        <Link to="/admins">
                            <li
                                className={`li ${pathname === '/admins' && 'active'}`}
                                onClick={()=>setActive(false)}
                            >
                                <span className="icon">{FaUserShield({})}</span>
                                <p className="text">المسؤلون</p>
                            </li>
                        </Link>
                    )}
                </ul>
                <div className="theme">
                    <p>السطوع</p>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={theme === 'dark'}
                            onChange={(e) => toggleTheme()}
                        />
                        <span className="slider"></span>
                    </label>
                </div>
                <div className="account">
                    <div className="user-info">
                        <p className="username">{user.username}</p>
                        <p className="role">مدير النظام</p>
                    </div>
                    <span className="logout" onClick={logout}>
                        {FiLogOut({})}
                    </span>
                </div>
            </aside>
            <div className={`blurOverLay ${active? `active`:''}`} onClick={()=>setActive(false)}></div>
        </>
    )
}

export default SideBar
